import React from 'react';
import T from 'prop-types';
import classnames from 'classnames/bind';
import styles from './FieldError.mod.css';

const cn = classnames.bind(styles);

const FieldError = ({ error, touched, centered }) =>
  error && touched ? (
    <div className={cn(styles.error, { centered })}>{Array.isArray(error) ? error.join(', ') : error}</div>
  ) : null;

FieldError.propTypes = {
  error: T.oneOfType([T.string, T.array]),
  touched: T.bool
};

export default FieldError;



// WEBPACK FOOTER //
// ./src/components/Form/FieldError.jsx